import { Component, Signal } from '@angular/core';
import { ContentComponent } from '../../components/content/content.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ServiceAppEntityServiceRead, SubpageAppEntitySubpageRead } from '../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-subpage-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    CommonModule
  ],
  templateUrl: './subpage-page.component.html'
})
export class SubpagePageComponent {

  public subpage: Signal<SubpageAppEntitySubpageRead | undefined> = toSignal((this.route.data as any)
    .pipe(map((v: { subpage: ServiceAppEntityServiceRead | null }) => v.subpage)));

  constructor(private route: ActivatedRoute) {
  }
}
